module.exports = __webpack_public_path__ + "img/7212a81.png";